import React from "react";

interface StepIndicatorHeaderProps {
  stepNumber: number;
  title: string;
  description: string;
  className?: string;
}

export const StepIndicatorHeader: React.FC<StepIndicatorHeaderProps> = ({
  stepNumber,
  title,
  description,
  className = "",
}) => {
  return (
    <div className={`text-center ${className}`}>
      <div className="inline-flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3 md:mb-4">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-sky-500 to-sky-600 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-white text-sm sm:text-lg font-bold">{stepNumber}</span>
        </div>
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 truncate">{title}</h3>
      </div>
      <p className="text-sm sm:text-base text-gray-600 px-2 sm:px-0">{description}</p>
    </div>
  );
};
